import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '@/features/auth';

/** Target of the reset email. Reachable with a session too: the link was requested on purpose. */
export const Route = createFileRoute('/(public)/reset-password')({
  validateSearch: z.object({ token: z.string().optional() }),
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  return <ResetPasswordPage token={token} />;
}
